import { render, staticRenderFns } from "./PersonaSelector.vue?vue&type=template&id=1b56b132&scoped=true"
import script from "./PersonaSelector.vue?vue&type=script&lang=js"
export * from "./PersonaSelector.vue?vue&type=script&lang=js"
import style0 from "./PersonaSelector.vue?vue&type=style&index=0&id=1b56b132&prod&scoped=true&lang=scss"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "1b56b132",
  null
  
)

export default component.exports